import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import usersReducer from './users/usersSlice';
import companiesReducer from './companies/companiesSlice';
import companyProfileReducer from './companyProfile/companyProfileSlice';
import surveysReducer from './surveys/surveysSlice';
import customizeTemplateReducer from './customizeTemplate/customizeTemplateSlice';
import aiTemplateReducer from './aiTemplate/aiTemplateSlice';
import apiLogsReducer from './apiLogs/apiLogsSlice';
import accessLogsReducer from './accessLogs/accessLogsSlice';
import processesReducer from './processes/processesSlice';
import devicesReducer from './devices/devicesSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  users: usersReducer,
  companies: companiesReducer,
  companyProfile: companyProfileReducer,
  surveys: surveysReducer,
  customizeTemplate: customizeTemplateReducer,
  aiTemplate: aiTemplateReducer,
  apiLogs: apiLogsReducer,
  accessLogs: accessLogsReducer,
  processes: processesReducer,
  devices: devicesReducer,
});

export default rootReducer;
